import { Controller } from "@hotwired/stimulus";

// Copy prompt textarea to clipboard. Updates button label to "Skopiowano!" for 2s.
export default class extends Controller {
  static targets = ["promptArea", "copyBtn"];

  async copyPrompt(event) {
    event.preventDefault();
    if (!this.hasPromptAreaTarget) return;

    const text = this.promptAreaTarget.value;
    try {
      await navigator.clipboard.writeText(text);
      this.flashSuccess();
    } catch (err) {
      // Fallback for older browsers / when clipboard API blocked
      this.promptAreaTarget.select();
      document.execCommand("copy");
      this.flashSuccess();
    }
  }

  flashSuccess() {
    if (!this.hasCopyBtnTarget) return;
    const original = this.copyBtnTarget.innerText;
    this.copyBtnTarget.innerText = "✓ Skopiowano!";
    this.copyBtnTarget.classList.add("bg-emerald-600", "dark:bg-emerald-500");
    this.copyBtnTarget.classList.remove("bg-indigo-600", "dark:bg-indigo-500");
    setTimeout(() => {
      this.copyBtnTarget.innerText = original;
      this.copyBtnTarget.classList.remove("bg-emerald-600", "dark:bg-emerald-500");
      this.copyBtnTarget.classList.add("bg-indigo-600", "dark:bg-indigo-500");
    }, 2000);
  }
}
